import * as types from './types';

export default {
    [types.REGISTER_SHARE_TASK](state, taskId) {
        if (!state.shareTaskList.includes(taskId)) {
            state.shareTaskList.push(taskId);
        }
    },
    [types.REMOVE_SHARE_TASK](state, taskId) {
        const index = state.shareTaskList.indexOf(taskId);
        if (index >= 0) {
            state.shareTaskList.splice(index, 1);
        }
    },
};
